import React from 'react'
import './ReadOnlyDetailsCard.sass'

/**
 * Read-only label/value card (system data block).
 * @param {{ title?: string, rows: Array<{ label: string, value: React.ReactNode, mono?: boolean }> }} props
 */
function ReadOnlyDetailsCard({ title = 'Системні дані', rows = [] }) {
  return (
    <div className="ReadOnlyDetailsCard">
      {title ? <p className="ReadOnlyDetailsCard-Title">{title}</p> : null}
      <dl className="ReadOnlyDetailsCard-List">
        {rows.map((row, index) => (
          <div key={`${row.label}-${index}`} className="ReadOnlyDetailsCard-Row">
            <dt>{row.label}</dt>
            <dd className={row.mono ? 'ReadOnlyDetailsCard-Mono' : undefined}>{row.value ?? '—'}</dd>
          </div>
        ))}
      </dl>
    </div>
  )
}

export default ReadOnlyDetailsCard
